import React from 'react';
import { motion } from 'framer-motion';

import banner2 from '../assets/banner2.png';

const Disclosure = () => {
const disclosureData = [
    { type: "Liquid/Ultra Short Term Schemes", trail: "0.05% – 0.70%" },
    { type: "Short Term Income Funds", trail: "0.50% – 0.90%" },
    { type: "Income Funds", trail: "0.40% – 1.00%" },
    { type: "Gilt Funds", trail: "0.15% – 0.90%" },
    { type: "Hybrid Debt/Monthly Income Plans", trail: "0.90% – 1.20%" },
    { type: "Arbitrage Funds", trail: "0.55% – 0.70%" },
    { type: "Fund of Funds", trail: "0.25% – 0.50%" },
    { type: "ELSS", trail: "0.65% – 2.00%" },
    { type: "Index Funds", trail: "0.30% – 1.00%" },
    { type: "Equity/ Hybrid Equity/ Balance Funds", trail: "0.65% – 2.00%" },
    { type: "Fixed Maturity Plans", trail: "Variable" },
  ];
  return (
    <div className="bg-white min-h-screen">
      {/* ================= HERO SECTION (Standard Theme) ================= */}
      <section
        className="relative py-16 md:py-24 text-center overflow-hidden"
        style={{
          backgroundImage: `url(${banner2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h3 className="relative z-10 font-syne text-[28px] md:text-[40px] text-slate-900 tracking-tight font-medium">
        Disclosure
        </h3>

        <div
          className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
          style={{
            background:
              "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
          }}
        />
      </section>

   <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="overflow-hidden border border-slate-200 rounded-lg shadow-sm"
          >
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-200">
                  <th className="px-6 py-4 text-sm font-bold text-slate-900 uppercase tracking-wider">
                    Scheme Type
                  </th>
                  <th className="px-6 py-4 text-sm font-bold text-slate-900 uppercase tracking-wider">
                    Trail-1st Year onwards
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200">
                {disclosureData.map((row, index) => (
                  <tr key={index} className="hover:bg-slate-50 transition-colors">
                    <td className="px-6 py-4 text-slate-600 text-lg md:text-xl leading-relaxed">
                      {row.type}
                    </td>
                    <td className="px-6 py-4 text-slate-600 text-lg md:text-xl leading-relaxed">
                      {row.trail}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </motion.div>
          
        
{/* New Content Section Added Below */}
          <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            viewport={{ once: true }}
            className="mt-10 space-y-4 text-slate-900  "
          >
            <p>
              Details of Scheme level commission on Mutual funds are available with the Relationship Managers and would be produced on demand.
            </p>
            <p>
              This is on a best effort basis and rates are updated as and when actual rates are received from AMCs.
            </p>
            <p className="font-medium text-slate-900 pt-2">
              We are a NISM certified / AMFI registered mutual fund distributor and not an RIA. We get compensated / incentivised by AMCs. We don't charge any fees for our services.
            </p>
          </motion.div>

        </div>
      </section>


    </div>
  );
};

export default Disclosure;